import axios from "axios";
import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken";

export default async function extractEquipmentsFromXml(file, prefix) {
  const token = await getOrRefreshFirebaseToken();
  const formData = new FormData();
  formData.append("file", file);

  const res = await axios.post(`${prefix}equipments/extract-from-xml`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  });

  return res.data;
}